import { render, staticRenderFns } from "./PqrTableDetails.vue?vue&type=template&id=7df76302"
import script from "./PqrTableDetails.vue?vue&type=script&lang=js"
export * from "./PqrTableDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports